export const LOADING_UI = "LOADING_UI";
export const STOP_LOADING_UI = "STOP_LOADING_UI";

export const LOADING_GOVERNMENT_UI = "LOADING_GOVERNMENT_UI";
export const STOP_LOADING_GOVERNMENT_UI = "STOP_LOADING_GOVERNMENT_UI";

export const LOADING_POLITICALPARTY_UI = "LOADING_POLITICALPARTY_UI";
export const STOP_LOADING_POLITICALPARTY_UI = "STOP_LOADING_POLITICALPARTY_UI";

export const LOADING_POLITICIAN_UI = "LOADING_POLITICIAN_UI";
export const STOP_LOADING_POLITICIAN_UI = "STOP_LOADING_POLITICIAN_UI";

export const LOADING_DATA = "LOADING_DATA";
export const SET_ERRORS = "SET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const STOP_LOADING_USER = "STOP_LOADING_USER";
export const START_LOADING_USER = "START_LOADING_USER";
export interface LoadingData {
  type: typeof LOADING_DATA;
}
export interface StopLoadingUI {
  type: typeof STOP_LOADING_UI;
}

export interface LoadingGovernmentUI {
  type: typeof LOADING_GOVERNMENT_UI;
}

export interface StopLoadingGovernmentUI {
  type: typeof STOP_LOADING_GOVERNMENT_UI;
}

export interface LoadingPoliticalPartyUI {
  type: typeof LOADING_POLITICALPARTY_UI;
}

export interface StopLoadingPoliticalPartyUI {
  type: typeof STOP_LOADING_POLITICALPARTY_UI;
}

export interface LoadingPoliticianUI {
  type: typeof LOADING_POLITICIAN_UI;
}

export interface StopLoadingPoliticianUI {
  type: typeof STOP_LOADING_POLITICIAN_UI;
}

export interface LoadingUI {
  type: typeof LOADING_UI;
}
export interface SetErrors {
  type: typeof SET_ERRORS;
}
export interface ClearErrors {
  type: typeof CLEAR_ERRORS;
}
export interface StopLoadingUser {
  type: typeof STOP_LOADING_USER;
}

export interface StartLoadingUser {
  type: typeof START_LOADING_USER;
}
export type UiDispatchTypes =
  | LoadingData
  | StopLoadingUI
  | LoadingUI
  | SetErrors
  | ClearErrors
  | LoadingGovernmentUI
  | StopLoadingGovernmentUI
  | LoadingPoliticalPartyUI
  | StopLoadingPoliticalPartyUI
  | LoadingPoliticianUI
  | StopLoadingPoliticianUI
  | StartLoadingUser
  | StopLoadingUser;
